import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';
import getters from '@/modules/templates/store/getters';

const state = {
  templateForm: {
    id: 0,
    name: '',
    type: '',
    size: '',
    content: '',
    live: false,
  },
  selectedTemplates: [],
  availableTemplates: [],
  isCreativeTemplateGroupChanged: false,
  creativesTemplatesEditableProperties: {},
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
